import { ExportTypes } from "../../shared/enum/shared.enum";

export class FiltroRelLiquidacao {
    codigoProjeto: string;
    dataInicial: Date;
    dataFinal: Date;
    escopoNumeroPed: number;
    numeroPedInicial: string;
    numeroPedFinal: string;
    escopoNumeroEmp: number;
    numeroEmpInicial: string;
    numeroEmpFinal: string;
    escopoNumeroLiq: number;
    numeroLiqInicial: string;
    numeroLiqFinal: string;
    numeroProcessoSei: string;
    historico: string;
    tipoInformacaoCredor: number;
    informacaoCredor: string;
    tipoInformacaoCredorConsignataria: number;
    informacaoCredorConsignataria: string;
    escopoValorLiq: number;
    valorLiqInicial?: number;
    valorLiqFinal?: number;
    tipoExportacao: ExportTypes;

    constructor(codigoProjeto: string) {
        this.codigoProjeto = codigoProjeto;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/pagamento/filtro-rel-liquidacao.ts